import captureSentryException from '@/features/app/functions/captureSentryException';
import { ALL_POSSIBLE_USER_ROLES } from '@/features/user/constants/user-role';
import RootLayout from '@/features/app/components/layout/main';
import RoleGuard from './features/auth/components/auth-guard';

const routes = [
  {
    element: (
      <RoleGuard requiredRoles={ALL_POSSIBLE_USER_ROLES.filter((role) => role !== 'GUEST')}>
        <RootLayout />
      </RoleGuard>
    ),
    children: [
      {
        index: true,
        // element: <HomePage />,
        async lazy() {
          const HomePage = await import('./features/app/routes/home').catch((error) => {
            captureSentryException(error, {
              message: 'failed to load page',
              tags: {
                feature: 'router',
              },
            });
            return Promise.reject(error);
          });
          return { Component: HomePage.default };
        },
      },
    ],
  },
  // webshop - part of webshop
  {
    element: (
      <RoleGuard requiredRoles={['ROLE_WEBSHOP_USER']}>
        <RootLayout />
      </RoleGuard>
    ),
    children: [
      {
        path: 'products',
        // element: <ProductPage />,
        async lazy() {
          const ProductPage = await import('./features/products/routes/products').catch((error) => {
            captureSentryException(error, {
              message: 'failed to load page',
              tags: {
                feature: 'router',
              },
            });
            return Promise.reject(error);
          });
          return { Component: ProductPage.default };
          // return { Component: () => <div>ProductPage</div> };
        },
      },
      {
        path: 'products/:id',
        async lazy() {
          const ProductDetailPage =
            await import('./features/products/routes/products/[id]/page').catch((error) => {
              captureSentryException(error, {
                message: 'failed to load page',
                tags: {
                  feature: 'router',
                },
              });
              return Promise.reject(error);
            });
          return { Component: ProductDetailPage.default };
        },
      },
      {
        path: 'product-bundles',
        async lazy() {
          const ProductBundlesPage =
            await import('./features/products/routes/product-bundles').catch((error) => {
              captureSentryException(error, {
                message: 'failed to load page',
                tags: {
                  feature: 'router',
                },
              });
              return Promise.reject(error);
            });
          return { Component: ProductBundlesPage.default };
        },
      },
      {
        path: 'promotions',
        async lazy() {
          const PromotionsPage = await import('./features/promotions/routes/promotions').catch(
            (error) => {
              captureSentryException(error, {
                message: 'failed to load page',
                tags: {
                  feature: 'router',
                },
              });
              return Promise.reject(error);
            }
          );
          return { Component: PromotionsPage.default };
        },
      },
      {
        path: 'cart',
        // element: <CartPage />,
        async lazy() {
          const CartPage = await import('./features/cart/routes/cart/page').catch((error) => {
            captureSentryException(error, {
              message: 'failed to load page',
              tags: {
                feature: 'router',
              },
            });
            return Promise.reject(error);
          });
          return { Component: CartPage.default };
        },
      },
      {
        path: 'orders',
        // element: <OrderPage />,
        async lazy() {
          const OrderPage = await import('./features/orders/routes/index').catch((error) => {
            captureSentryException(error, {
              message: 'failed to load page',
              tags: {
                feature: 'router',
              },
            });
            return Promise.reject(error);
          });
          return { Component: OrderPage.default };
        },
      },
      {
        path: 'reserved-stocks',
        // element: <ReservedStockPage />,
        async lazy() {
          const ReservedStockPage = await import('./features/reserved-stocks/routes/index').catch(
            (error) => {
              captureSentryException(error, {
                message: 'failed to load page',
                tags: {
                  feature: 'router',
                },
              });
              return Promise.reject(error);
            }
          );
          return { Component: ReservedStockPage.default };
        },
      },
      {
        path: 'notifications',
        // element: <NotificationPage />,
        async lazy() {
          const NotificationPage = await import('./features/app/routes/notification').catch(
            (error) => {
              captureSentryException(error, {
                message: 'failed to load page',
                tags: {
                  feature: 'router',
                },
              });
              return Promise.reject(error);
            }
          );
          return { Component: NotificationPage.default };
        },
      },
      {
        path: 'dashboard',
        // element: <DashboardPage />,
        async lazy() {
          const DashboardPage = await import('./features/dashboard/routes/index').catch((error) => {
            captureSentryException(error, {
              message: 'failed to load page',
              tags: {
                feature: 'router',
              },
            });
            return Promise.reject(error);
          });
          return { Component: DashboardPage.default };
        },
      },
    ],
  },
  // webshop/admin user profile part of webshop
  {
    element: (
      <RoleGuard requiredRoles={['ROLE_ADMIN', 'ROLE_WEBSHOP_USER']}>
        <RootLayout />
      </RoleGuard>
    ),
    children: [
      {
        path: 'user',
        // element: <UserLayout />,
        async lazy() {
          const UserLayout = await import('./features/user/components/user-layout').catch(
            (error) => {
              captureSentryException(error, {
                message: 'failed to load page',
                tags: {
                  feature: 'router',
                },
              });
              return Promise.reject(error);
            }
          );
          return { Component: UserLayout.default };
        },
        children: [
          {
            path: 'profile',
            // element: <ProfilePage />,
            async lazy() {
              const ProfilePage = await import('./features/user/routes/profile/page').catch(
                (error) => {
                  captureSentryException(error, {
                    message: 'failed to load page',
                    tags: {
                      feature: 'router',
                    },
                  });
                  return Promise.reject(error);
                }
              );
              return { Component: ProfilePage.default };
            },
          },
          {
            path: 'security',
            // element: <SecurityPage />,
            async lazy() {
              const SecurityPage = await import('./features/user/routes/security/page').catch(
                (error) => {
                  captureSentryException(error, {
                    message: 'failed to load page',
                    tags: {
                      feature: 'router',
                    },
                  });
                  return Promise.reject(error);
                }
              );
              return { Component: SecurityPage.default };
            },
          },
          {
            path: 'complaints',
            // element: <ComplaintsPage />,
            async lazy() {
              const ComplaintsPage = await import('./features/user/routes/complaint/page').catch(
                (error) => {
                  captureSentryException(error, {
                    message: 'failed to load page',
                    tags: {
                      feature: 'router',
                    },
                  });
                  return Promise.reject(error);
                }
              );
              return { Component: ComplaintsPage.default };
            },
          },
          {
            path: 'accounting',
            // element: <AccountingPage />,
            async lazy() {
              const AccountingPage = await import('./features/user/routes/accounting/page').catch(
                (error) => {
                  captureSentryException(error, {
                    message: 'failed to load page',
                    tags: {
                      feature: 'router',
                    },
                  });
                  return Promise.reject(error);
                }
              );
              return { Component: AccountingPage.default };
            },
          },
          {
            path: 'notification-settings',
            // element: <NotificationSettings />,
            async lazy() {
              const NotificationSettings =
                await import('./features/user/routes/notification-settings/page').catch((error) => {
                  captureSentryException(error, {
                    message: 'failed to load page',
                    tags: {
                      feature: 'router',
                    },
                  });
                  return Promise.reject(error);
                });
              return { Component: NotificationSettings.default };
            },
          },
        ],
      },
    ],
  },
  // admin route - part of webshop
  {
    path: 'admin',
    element: (
      <RoleGuard requiredRoles={['ROLE_ADMIN']}>
        <RootLayout />
      </RoleGuard>
    ),
    children: [
      {
        // element: <AdminLayout />,
        lazy: async () => {
          const AdminLayout = await import('./app/admin/layout').catch((error) => {
            captureSentryException(error, {
              message: 'failed to load page',
              tags: {
                feature: 'router',
              },
            });
            return Promise.reject(error);
          });
          return { Component: AdminLayout.default };
        },
        children: [
          {
            index: true,
            // element: <AdminHomePage />,
            async lazy() {
              const AdminHomePage = await import('./app/admin/page').catch((error) => {
                captureSentryException(error, {
                  message: 'failed to load page',
                  tags: {
                    feature: 'router',
                  },
                });
                return Promise.reject(error);
              });
              return { Component: AdminHomePage.default };
            },
          },
          {
            path: 'analytics',
            children: [
              {
                // element: <AnalyticsPage />,
                index: true,
                async lazy() {
                  const AnalyticsPage = await import('./app/admin/analytics/page').catch(
                    (error) => {
                      captureSentryException(error, {
                        message: 'failed to load page',
                        tags: {
                          feature: 'router',
                        },
                      });
                      return Promise.reject(error);
                    }
                  );
                  return { Component: AnalyticsPage.default };
                },
              },
              {
                path: 'user',
                children: [
                  {
                    index: true,
                    // element: <AnalyticsUserPage />,
                    async lazy() {
                      const AnalyticsUserPage =
                        await import('./app/admin/analytics/user/page').catch((error) => {
                          captureSentryException(error, {
                            message: 'failed to load page',
                            tags: {
                              feature: 'router',
                            },
                          });
                          return Promise.reject(error);
                        });
                      return { Component: AnalyticsUserPage.default };
                    },
                  },
                  {
                    path: ':id',
                    async lazy() {
                      const AnalyticsUserDetailsPage =
                        await import('./app/admin/analytics/user/[id]/page').catch((error) => {
                          captureSentryException(error, {
                            message: 'failed to load page',
                            tags: {
                              feature: 'router',
                            },
                          });
                          return Promise.reject(error);
                        });
                      return { Component: AnalyticsUserDetailsPage.default };
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'users',
            // element: <UserPage />,
            async lazy() {
              const UserPage = await import('./app/admin/users/page').catch((error) => {
                captureSentryException(error, {
                  message: 'failed to load page',
                  tags: {
                    feature: 'router',
                  },
                });
                return Promise.reject(error);
              });
              return { Component: UserPage.default };
            },
          },
          {
            path: 'dashboard-settings',
            // element: <DashboardSettingPage />,
            async lazy() {
              const DashboardSettingPage = await import('./app/admin/dashboard-setting/page').catch(
                (error) => {
                  captureSentryException(error, {
                    message: 'failed to load page',
                    tags: {
                      feature: 'router',
                    },
                  });
                  return Promise.reject(error);
                }
              );
              return { Component: DashboardSettingPage.default };
            },
          },
          {
            path: 'email-settings',
            // element: <EmailRecipientSettingPage />,
            async lazy() {
              const EmailRecipientSettingPage =
                await import('./app/admin/email-settings/page').catch((error) => {
                  captureSentryException(error, {
                    message: 'failed to load page',
                    tags: {
                      feature: 'router',
                    },
                  });
                  return Promise.reject(error);
                });
              return { Component: EmailRecipientSettingPage.default };
            },
          },
          {
            path: 'import-export-settings',
            // element: <ImportExportSettingsPage />,
            async lazy() {
              const ImportExportSettingsPage =
                await import('./app/admin/import-export-settings/page').catch((error) => {
                  captureSentryException(error, {
                    message: 'failed to load page',
                    tags: {
                      feature: 'router',
                    },
                  });
                  return Promise.reject(error);
                });
              return { Component: ImportExportSettingsPage.default };
            },
          },
        ],
      },
    ],
  },
  // auth routes
  {
    path: '/auth',
    element: (
      <RoleGuard requiredRoles={['GUEST']}>
        <RootLayout />
      </RoleGuard>
    ),
    children: [
      {
        path: 'login',
        // don't lazy load page since it's critial
        // element: <LoginPage />,
        async lazy() {
          const LoginPage = await import('./features/auth/routes/login/page').catch((error) => {
            captureSentryException(error, {
              message: 'failed to load page',
              tags: {
                feature: 'router',
              },
            });
            return Promise.reject(error);
          });
          return { Component: LoginPage.default };
        },
      },
      {
        path: 'register',
        // element: <RegisterPage />,
        async lazy() {
          const RegisterPage = await import('./features/auth/routes/register/page').catch(
            (error) => {
              captureSentryException(error, {
                message: 'failed to load page',
                tags: {
                  feature: 'router',
                },
              });
              return Promise.reject(error);
            }
          );
          return { Component: RegisterPage.default };
        },
      },
      {
        path: 'register/success',
        // element: <RegisterSuccessPage />,
        async lazy() {
          const RegisterSuccessPage = await import('./features/auth/routes/register/success').catch(
            (error) => {
              captureSentryException(error, {
                message: 'failed to load page',
                tags: {
                  feature: 'router',
                },
              });
              return Promise.reject(error);
            }
          );
          return { Component: RegisterSuccessPage.default };
        },
      },
      {
        path: 'onboarding/:token',
        // element: <OnboardingPage />,
        async lazy() {
          const OnboardingPage = await import('./features/auth/routes/onboarding/page').catch(
            (error) => {
              captureSentryException(error, {
                message: 'failed to load page',
                tags: {
                  feature: 'router',
                },
              });
              return Promise.reject(error);
            }
          );
          return { Component: OnboardingPage.default };
        },
      },
      {
        path: 'reset-password/:token',
        // element: <ResetPasswordPage />,
        async lazy() {
          const ResetPasswordPage =
            await import('./features/auth/routes/reset-password/page').catch((error) => {
              captureSentryException(error, {
                message: 'failed to load page',
                tags: {
                  feature: 'router',
                },
              });
              return Promise.reject(error);
            });
          return { Component: ResetPasswordPage.default };
        },
      },
    ],
  },
  // other routes
  {
    path: '/brand',
    element: (
      <RoleGuard requiredRoles={ALL_POSSIBLE_USER_ROLES}>
        <RootLayout />
      </RoleGuard>
    ),
    children: [
      {
        index: true,
        // element: <BrandPage />,
        async lazy() {
          const BrandPage = await import('./features/custom-pages/routes/brand/page').catch(
            (error) => {
              captureSentryException(error, {
                message: 'failed to load page',
                tags: {
                  feature: 'router',
                },
              });
              return Promise.reject(error);
            }
          );
          return { Component: BrandPage.default };
        },
      },
      {
        path: ':id',
        async lazy() {
          const CustomPage = await import('./features/custom-pages/routes/brand/[id]/page').catch(
            (error) => {
              captureSentryException(error, {
                message: 'failed to load page',
                tags: {
                  feature: 'router',
                },
              });
              return Promise.reject(error);
            }
          );
          return { Component: CustomPage.default };
        },
      },
    ],
  },
  // {
  //   path: 'mockup',
  //   element: (
  //     <RoleGuard requiredRoles={['ROLE_WEBSHOP_USER']}>
  //       <MockupProvider>
  //         <MockupRootLayout />
  //       </MockupProvider>
  //     </RoleGuard>
  //   ),
  //   children: [
  //     {
  //       path: 'products',
  //       // element: <MockupProductPage />,
  //       async lazy() {
  //         const MockupProductPage = await import('./app/mockup/products/page').catch(
  //           (error) => {
  //             captureSentryException(error, {
  //   message: 'failed to load page',
  //   tags: {
  //     feature: 'router'
  //   }
  // });
  //             return Promise.reject(error);
  //           }
  //         );
  //         return { Component: MockupProductPage.default };
  //       },
  //     },
  //     {
  //       path: 'cart',
  //       // element: <MockupCartPage />,
  //       async lazy() {
  //         const MockupCartPage = await import('./app/mockup/cart/page').catch((error) => {
  //           captureSentryException(error, {
  //   message: 'failed to load page',
  //   tags: {
  //     feature: 'router'
  //   }
  // });
  //           return Promise.reject(error);
  //         });
  //         return { Component: MockupCartPage.default };
  //       },
  //     },
  //   ],
  // },
  {
    path: '*',
    element: (
      <RoleGuard requiredRoles={ALL_POSSIBLE_USER_ROLES}>
        <RootLayout />
      </RoleGuard>
    ),
    children: [
      {
        path: '*',
        async lazy() {
          const CustomPage = await import('./features/custom-pages/routes/[index]/page').catch(
            (error) => {
              captureSentryException(error, {
                message: 'failed to load page',
                tags: {
                  feature: 'router',
                },
              });
              return Promise.reject(error);
            }
          );
          return { Component: CustomPage.default };
        },
      },
    ],
  },
];

export default routes;
